export const isMatchCashout = () => {
  if (location.href.match(/cashout/)) {
    return true;
  }
  return false;
};

export const isMatchGateway = () => {
  if (location.href.match(/gateway/)) {
    return true;
  }
  return false;
};

export const isMatchAuth = () => {
  if (location.href.match(/authentication\/login/)) {
    return true;
  }
  return false;
};
